(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media-gallery"] && !Shopify.designMode) return;
  try {
    function normalizeUrl(url) {
    if (!url) return '';

    let normalized = url.replace(/^https?:/, '');
    normalized = normalized.replace(/=\d+$/, '');

    return normalized;
  }

  const imageUrls = [];
  const normalizedImageUrls = [];
  let thumbnailItems = [];

  document.addEventListener('DOMContentLoaded', () => {
    const thumbImages = document.querySelectorAll(
      '.thumbnail-list .thumb-img'
    );

    thumbnailItems = Array.from(
      document.querySelectorAll('.thumbnail-list .thumbnail-item')
    );

    thumbImages.forEach((img) => {
      const url = img.currentSrc || img.src; // e.g. https://...&width=300
      imageUrls.push(url);

      const normalized = normalizeUrl(url);
      normalizedImageUrls.push(normalized);
    });
  });

  document.addEventListener('click', (event) => {
    const label = event.target.closest('.product-variant-option-label');
    if (!label) return;

    /*
      --- A. GET VARIANT PRICE AND UPDATE PRICE SPAN ---
      We use the variant ID from the URL (?variant=...) and
      lookup in window.meta.product.variants
    */
    const currentUrl = new URL(window.location.href);
    const variantId = currentUrl.searchParams.get('variant'); // e.g. "50847004819754"

    if (
      variantId &&
      window.meta &&
      window.meta.product &&
      Array.isArray(window.meta.product.variants)
    ) {
      const variants = window.meta.product.variants;

      const variant = variants.find((v) => String(v.id) === String(variantId));

      if (variant) {
        // Shopify JS data: price is usually in cents
        const priceInCents = variant.price;
        const formattedPrice = (priceInCents / 100).toFixed(2); // "123.45"

        // Select the regular price span from price.liquid
        const priceSpan = document.querySelector(
          '.price-item.price-item--regular'
        );

        if (priceSpan) {
          // If you want a $ sign:
          priceSpan.textContent = '$' + formattedPrice;

          // Or, if the theme already prints currency elsewhere:
          // priceSpan.textContent = formattedPrice;
        } else {
          console.warn('Regular price span (.price-item--regular) not found');
        }

        // Optional: log to console for debugging
        console.log(
          'Variant selected:',
          variantId,
          'price (cents):',
          priceInCents,
          'formatted: $' + formattedPrice
        );
      } else {
        console.warn('Variant not found for ID:', variantId);
      }
    } else {
      console.warn('No variant ID in URL or window.meta.product.variants not available');
    }

    /*
      --- B. EXISTING IMAGE / THUMBNAIL LOGIC ---
    */
    const imageUrl = label.dataset.variantImageUrl;
    if (!imageUrl) return;

    const normalizedVariantUrl = normalizeUrl(imageUrl);

    const matchIndex = normalizedImageUrls.indexOf(normalizedVariantUrl);

    if (matchIndex === -1) {
      console.log('No matching thumbnail for variant URL');
      return;
    }

    console.log('Matched thumbnail index:', matchIndex);
    console.log('Matched thumbnail full URL:', imageUrls[matchIndex]);

    // Highlight the matched thumbnail
    thumbnailItems.forEach((item) => item.classList.remove('is-active'));

    const matchedItem = thumbnailItems[matchIndex];
    if (matchedItem) {
      matchedItem.classList.add('is-active');

      // TRIGGER the thumbnail as if user clicked it
      matchedItem.click();

      // If your slider listens to img click instead of li:
      // const matchedImg = matchedItem.querySelector('.thumb-img');
      // if (matchedImg) matchedImg.click();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
